import SimpleHeader from '../../components/layout/SimpleHeader';
import { Table, TableColumnsType } from 'antd';
import Button from '../../components/Button';
import useNotification from '../../hooks/useNotification';
import useAxios from '../../hooks/useAxios';
import {
  IGetPtCurriculums,
  IGetTestTypes,
  IPtCurriculum,
  ITestType,
} from '../../models/testCenter.model';
import Loader from '../../components/Loader';
import ErrorResponse from '../../components/ErrorResponse';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  getPtCurriculums,
  getTestTypes,
  updatePtCurriculums,
} from '../../api/testCenter.api';
import _ from 'lodash';
import SelectLevel from '../../components/SelectLevel';
import styled from 'styled-components';
import useAuth from '../../hooks/useAuth';
import { IGetSteps } from '../../models/courses.model';
import { getSteps2 } from '../../api/courses.api';
import SelectEduStepContainer from '../../components/SelectEduStepContainer';
import Split from 'react-split';

const Block = styled.div`
  .table-custom {
    margin-top: 20px;
  }
`;

const CbtClass = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const { successNotification, infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetTestTypes>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetPtCurriculums>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetSteps>();
  const { data: updateRes, isLoading: updateIsLoading, error: updateError, execute: updateExecute } = useAxios();

  const [eduStepCode, setEduStepCode] = useState('');
  const [pts, setPts] = useState<ITestType[]>([]);
  const [ptCode, setPtCode] = useState<number>();
  const [data, setData] = useState<IPtCurriculum[]>([]);

  useEffect(() => {
    if (eduStepCode) {
      execute(getTestTypes({ eduStepCode }));
      execute3(getSteps2(eduStepCode));
      setPtCode(undefined);
      setData([]);
    }
  }, [eduStepCode]);

  useEffect(() => {
    if (res) {
      const _data: ITestType[] = _.cloneDeep(res.data);
      const _pts = _data.filter((item) => item.examDiv === 'PT');
      setPts(_pts);
    }
  }, [res]);

  useEffect(() => {
    if (res2) {
      let _data: IPtCurriculum[] = _.cloneDeep(res2.data);
      _data.forEach((item) => {
        item.status = 'update';
      });
      setData(_data);
    }
  }, [res2]);

  useEffect(() => {
    if (updateRes) {
      successNotification(t('common.message.save1'));
    }
  }, [updateRes]);

  const onSetData = (index: number, key: string, value: string) => {
    const _data: any = [...data];
    _data[index][key] = value;
    setData(_data);
  };

  const onSubmit = () => {
    if (!ptCode) return;

    let prevEndScore: number | null = null;
    for (let i = 0; i < data.length; i++) {
      if (
        data[i].srtScore === null ||
        data[i].endScore === null ||
        data[i].srtScore === '' ||
        data[i].endScore === '' ||
        !data[i].courseCode
      ) {
        return infoNotification(t('cbt.class.message1'));
      }
      if (prevEndScore && Number(data[i].srtScore) > prevEndScore + 1) {
        return infoNotification(t('cbt.class.message2'));
      }
      prevEndScore = Number(data[i].endScore);
    }

    updateExecute(updatePtCurriculums(ptCode, data));
  };

  const onAddRow = () => {
    if (!ptCode) {
      return infoNotification(t('cbt.class.message3'));
    }

    const _data: IPtCurriculum[] = [...data];
    _data.push({
      status: 'create',
      srtScore: null,
      endScore: null,
      courseCode: null,
    });
    setData(_data);
  };

  const onSelectPt = (ptCode: number) => {
    if (!ptCode) return;
    setPtCode(ptCode);
    execute2(getPtCurriculums(ptCode));
  };

  const columns: TableColumnsType<any> = [
    {
      title: t('cbt.class.column1'),
      dataIndex: 'platCurriculumCode',
      key: 'platCurriculumCode',
      align: 'center',
      render: (value, record, index) => (
        <div className="flex flex-justify-center">
          <div className="w-100p">
            <input
              type="text"
              className="form-control"
              value={record.srtScore}
              onChange={(e) => onSetData(index, 'srtScore', e.target.value)}
            />
          </div>
          <span className="v-line">&nbsp;~&nbsp;</span>
          <div className="w-100p">
            <input
              type="text"
              className="form-control"
              value={record.endScore}
              onChange={(e) => onSetData(index, 'endScore', e.target.value)}
            />
          </div>
        </div>
      ),
    },
    {
      title: t('cbt.class.column2'),
      key: 'courseCode',
      dataIndex: 'courseCode',
      align: 'center',
      render: (value, record, index) => (
        <div className="w-100">
          <SelectLevel
            value={value ? String(value) : value}
            onChange={value => onSetData(index, 'courseCode', value)}
            steps={res3?.data || []}
          />
        </div>
      ),
    },
  ];

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <SelectEduStepContainer
              eduStepCode={eduStepCode}
              setEduStepCode={setEduStepCode}
            />
          </li>
        </ul>
      </div>
    </div>	
    <Block className="content">
      {(isLoading || isLoading2 || isLoading3 || updateIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={updateError} />
      <SimpleHeader
        iconFile="icon-cbt-big.svg"
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.class.title1')}
        onlyTitle={true}
      />

      <Split
        className="splite-divide"
        sizes={[37, 63]}
        minSize={100}
        expandToMin={false}
        gutterSize={10}
        gutterAlign="center"
        snapOffset={30}
        dragInterval={1}
        direction="horizontal"
        cursor="col-resize"
      >
        <div className="col-frame left_panel">
          <div className='comm-bx__between'>
          </div>
          <div className='comm-table__area'>
            <table>
              <thead>
                <tr>
                  <th>Placement Test</th>
                </tr>
              </thead>
              <tbody>
                {pts?.map((item: ITestType) => (
                  <tr
                    key={item.examTypeCode}
                    className={
                      ptCode === item.examTypeCode ? 'chosen' : 'pointer'
                    }
                    onClick={() => onSelectPt(item.examTypeCode)}
                  >
                    <td>{item.examTypeName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-frame right_panel">
          <div className="comm-bx__between">
            <div></div>
            <div className="comm-btn__area right">
              <Button
                className="btn-basic pink-line"
                onClick={onAddRow}
                text={t('cbt.class.button1')}
                writeAuthYn={writeAuthYn}
              />
            </div>
          </div>
          <div className='comm-table__area'>
            <Table
              columns={columns}
              dataSource={data || undefined}
              pagination={{
                pageSize: 99999,
              }}
            />
          </div>
          <div className="comm-bx__space">
            <div className="comm-btn__area right">
              <Button
                className="btn-basic pink"
                onClick={onSubmit}
                text={t('common.button.save')}
                writeAuthYn={writeAuthYn}
                // test용 해제
                // disabled                  
              />
              <Button
                className="btn-basic pink-line"
                onClick={onAddRow}
                text={t('cbt.class.button1')}
                writeAuthYn={writeAuthYn}
              />
            </div>
          </div>
        </div>
      </Split>
    </Block>
    </>
  );
};

export default CbtClass;
